// extracted by mini-css-extract-plugin
export default {"root":"root--_3iXT","termsControl":"termsControl--OBFh3","checkbox":"checkbox--i67qO"};